import React from 'react';

// Custom brand mark — play diamond icon
const Logo = ({ className = '', withWordmark = true, size = 36, color = '#12367F' }) => {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`} style={{ color }}>
      <svg
        viewBox="0 0 22.5124 22.1608"
        width={size}
        height={size}
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className="shrink-0"
      >
        <path
          d="M13.2435 1.09505L21.056 8.90755C22.5013 10.3529 22.5111 11.7884 21.0853 13.2142L13.224 21.0853C11.7884 22.5111 10.3626 22.5013 8.91731 21.056L1.09505 13.2337C-0.350264 11.7884-0.369795 10.3626 1.06575 8.92708L8.93685 1.06575C10.3724-0.369795 11.7982-0.350264 13.2435 1.09505ZM8.58528 7.57942L8.58528 14.5814C8.58528 15.0697 9.12239 15.2943 9.59114 15.0111L15.3236 11.6322C15.7435 11.3783 15.7337 10.7923 15.3236 10.5482L9.59114 7.14974C9.16145 6.89583 8.58528 7.10091 8.58528 7.57942Z"
          fill="currentColor"
        />
      </svg>
      {withWordmark && (
        <span
          className="font-display text-2xl md:text-3xl tracking-tight leading-none whitespace-nowrap"
          style={{ color }}
        >
          Nasu Group
        </span>
      )}
    </span>
  );
};

export default Logo;
